import { useLocation } from 'react-router'
import {
  Topbar,
  TopbarNavLink,
  Logo,
  MobileNavGroup,
} from '@rr/ui'
import UserMenu from '@/components/layout/UserMenu'
import { NAV_GROUPS, findActiveGroup, findActiveTabHref } from '@/lib/nav'
import { HrefLink } from '@/src/href-link'

/**
 * RR Admin branded navbar.
 *
 * Responsive behaviour: the shared `Topbar` from `@rr/ui` provides the
 * hamburger + drawer below `lg` automatically as long as we pass
 * a `mobileNav` slot. Each top-level group becomes a collapsible
 * `MobileNavGroup` inside the drawer that expands to its sub-tabs.
 */
export default function TopNav() {
  const pathname = useLocation().pathname
  const active = findActiveGroup(pathname)

  return (
    <Topbar
      logo={
        <HrefLink
          href="/"
          aria-label="Route and Route — Admin"
          className="flex items-center gap-2 mr-4"
        >
          <Logo size={ 26 } />
          <span className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground border border-border rounded px-1.5 py-0.5 ml-1 hidden sm:inline">
            Admin
          </span>
        </HrefLink>
      }
      nav={
        <>
          { NAV_GROUPS.map((g) => (
            <TopbarNavLink
              key={ g.key }
              href={ g.href }
              active={ g.key === active.key }
              as={ HrefLink }
            >
              { g.label }
            </TopbarNavLink>
          )) }
        </>
      }
      mobileNavTitle="Admin"
      mobileNav={
        <>
          { NAV_GROUPS.map((group) => {
            const isActiveGroup = group.key === active.key
            const activeTabHref = isActiveGroup
              ? findActiveTabHref(group, pathname)
              : null

            return (
              <MobileNavGroup
                key={ group.key }
                label={ group.label }
                active={ isActiveGroup }
                defaultOpen={ isActiveGroup }
                items={ group.tabs.map((t) => ({
                  href: t.href,
                  label: t.label,
                  active: t.href === activeTabHref,
                  as: HrefLink,
                })) }
              />
            )
          }) }
        </>
      }
      right={
        <div className="flex items-center gap-2">
          <UserMenu />
        </div>
      }
    />
  )
}
